$(document).ready(function() {
  // Homepage
  velocitySlide();
  productListSlide();
  $(window).on('resize', function() {
    velocitySlide();
    productListSlide();
  });

  // Collection - Shop page
  filterDrawerHandle();
  sortByClick();
  filterByTagsClick();
  applyFilterClick();
  filterOptionMobile();
  scrollToTop();

  // Account B2B
  checkLogin();
  checkWholesale();

  // Clear search
  clearSearch();
});

function velocitySlide() {
  if ($(window).width() < 769) {
    if (!$('.js-velocity-slide').hasClass('slick-slider')) {
      $('.js-velocity-slide').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      });
    }
  } else {
    if ($('.js-velocity-slide').hasClass('slick-slider')) {
      $('.js-velocity-slide').slick('unslick');
    }
  }
}

function productListSlide() {
  if ($(window).width() < 608) {
    if (!$('.product-list-type_2').hasClass('slick-slider')) {
      $('.product-list-type_2').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 2,
        dots: false,
        arrows: false,
        rows: 1,
        swipeToSlide: true,
        // centerMode: true,
      });
    }
  } else {
    if ($('.product-list-type_2').hasClass('slick-slider')) {
      $('.product-list-type_2').slick('unslick');
    }
  }
}

function sortByClick() {
  $('.js-fs-sort').on('click', function() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $('.js-fs-sort').removeClass('active');
      $(this).addClass('active');
    }
  });
}

function filterByTagsClick() {
  $('.js-fs-filter').on('click', function() {
    $(this).toggleClass('active');
  });
}

function applyFilterClick() {
  $('.js-fs-apply').on('click', function() {
    let filterUrl = $(this).data('url');

    if ($('.js-fs-filter.active').length > 0) {
      $('.js-fs-filter.active').each(function(index) {
        let dataFilter = $(this).data('value');
        if (index == 0) {
          filterUrl = filterUrl + '/' + dataFilter;
        } else {
          filterUrl = filterUrl + '+' + dataFilter;
        }
      });
    }

    if ($('.js-fs-sort.active').length > 0) {
      filterUrl = filterUrl + '?sort_by=' + $('.js-fs-sort.active').data('value');
    }

    window.location.href = filterUrl;
  });
}

function filterDrawerHandle() {
  $('.js-open-filter-drawer').on('click', function() {
    $('body').addClass('overflow-hidden');
    $('[data-fs-drawer], .fs-drawer-overlay').addClass('is-visible');
  });

  $('.js-close-filter-drawer').on('click', function() {
    $('body').removeClass('overflow-hidden');
    $('[data-fs-drawer], .fs-drawer-overlay').removeClass('is-visible');
  });

  $('.fs-drawer-overlay').on('click', function() {
    $('body').removeClass('overflow-hidden');
    $('.fs-drawer-overlay, .filter-options-drawer, [data-fs-drawer]').removeClass('is-visible');
  });

  
}

function filterOptionMobile() {
  $('.js-open-filter-option').on('click', function() {
    $('body').addClass('overflow-hidden');
    $('.filter-options-drawer, .fs-drawer-overlay').addClass('is-visible');
  });

  $('.js-close-filter-drawer').on('click', function() {
    $('body').removeClass('overflow-hidden');
    $('.filter-options-drawer, .fs-drawer-overlay').removeClass('is-visible');
  });

  $('.js-filter-option').on('click', function(e) {
    if ($(window).width() < 960) {
      e.preventDefault();

      if (!$(this).hasClass('active')) {
        $('.js-filter-option').removeClass('active');
        $(this).addClass('active');

        if ($(this).hasClass('filter-option-default')) {
          $('.js-options-apply').attr('data-url', '');
        } else {
          let dataUrl = $(this).attr('href');
          $('.js-options-apply').attr('data-url', dataUrl);
        }
      }
    }
  });

  $('.js-options-apply').on('click', function() {
    let url = $(this).attr('data-url');
    if (url != '') {
      window.location.href = url;
    } else {
      $('body').removeClass('overflow-hidden');
      $('.fs-drawer-overlay, .filter-options-drawer').removeClass('is-visible');
    }
  });
}

function scrollToTop() {
  if($('.js-scroll-to-top').length > 0) {
    $(window).scroll(function(){
      if($(this).scrollTop() > 0){
        $('.js-scroll-to-top').show();
      } else {
        $('.js-scroll-to-top').hide();
      }
    });
  }
  $('.js-scroll-to-top').on('click', function() {
    $('html, body').animate({ 
      scrollTop: 0 
    }, 400);
  });
}

function checkLogin() {
  $('.js-btn-login').on('click', function(e) {
    e.preventDefault();

    if (typeof(Storage) !== 'undefined') {
      localStorage.setItem('CheckLogin', 'true');
    }

    $(this).closest('form').submit();
  });
}

function checkWholesale() {
  if (typeof(Storage) !== 'undefined') {
    if ($('.js-redirect-wholesale').length > 0) {
      let checkLogin = localStorage.getItem('CheckLogin');

      if (checkLogin == 'true') {
        localStorage.setItem('CheckLogin', 'false');
        let url = $('.js-redirect-wholesale').data('url');
        window.location.href = url;
      }
    } else {
      localStorage.setItem('CheckLogin', 'false');
    }
  }
}

function clearSearch() {
  $('.template-search #Search').on('keyup', function() {
    if ($(this).val().length > 0) {
      $('.js-clear-search').show();
    } else {
      $('.js-clear-search').hide();
    }
  });

  $('.js-clear-search').on('click', function() {
    $(this).hide();
    $('.template-search #Search').val('');
  });
}